// extracted by mini-css-extract-plugin
module.exports = {"Container":"ProfileCard_Container__1ESyL","ImgContainer":"ProfileCard_ImgContainer__XTzlI","AboutText":"ProfileCard_AboutText__wB9j4"};